import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69a1cad7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "id"]
const _hoisted_2 = ["src"]

import {Konami} from "@/utilities/konami";
import {onMounted, Ref, ref} from "vue";
import gsap from "gsap";
import {Circ} from "@/lib/common/interfaces/gsap";


export default /*#__PURE__*/_defineComponent({
  name: 'KonamiEvent',
  setup(__props) {


const isEventHappening = ref(false);

const konamiEventContainer = ref();

const nbCows = 50;

const cowsLeft: Ref<number[]> = ref([]);

onMounted(() =>
{
  Konami.start(() =>
  {
    isEventHappening.value = true;

    setTimeout(() =>
    {
      for (let i = 1; i <= nbCows; i++)
      {
        cowsLeft.value[i] = Math.floor(Math.random() * (konamiEventContainer.value.offsetWidth - 700)) + 300;
      }
    }, 100);

    setTimeout(() => {
      gsap.to("#ufo", {
        duration: 3,
        y: () => -konamiEventContainer.value.offsetHeight - 1000, // animate by the px width of the nav
        ease: Circ.easeOut,
        paused: true
      }).play();

      setTimeout(() => {
        gsap.to(".konami-event", {
          duration: 1,
          backgroundColor: 'rgba(253,228,119,0.26)',
          ease: "none",
        })
      }, 500)

      setTimeout(() =>
      {
        for (let cowId = 1; cowId <= nbCows; cowId++)
        {
          const startDelay = Math.random() * 2 * 1000;
          const duration = Math.random() * 4.8 + 0.2;

          setTimeout(() =>
          {
            gsap.to("#cow" + cowId, {
              duration: duration,
              y: () => -konamiEventContainer.value.offsetHeight - 200, // animate by the px width of the nav
              rotation: 360,
              ease: "none",
              paused: true
            }).play();
          }, startDelay);

        }

        setTimeout(() =>
        {
          gsap.to(".konami-event", {
            duration: 1,
            backgroundColor: 'rgba(255,255,255,0)',
            ease: "none",
          })
        }, 6000);

        setTimeout(() =>
        {
          isEventHappening.value = false; // ends the animation
        }, 8000);

      }, 1500)

    }, 500)
  });
})


return (_ctx: any,_cache: any) => {
  return (isEventHappening.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "konami-event",
        ref_key: "konamiEventContainer",
        ref: konamiEventContainer
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cowsLeft.value, (value, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            src: require('@/assets/icons/cow.svg'),
            alt: "ushi-chan",
            class: "cow",
            id: 'cow' + index,
            style: _normalizeStyle('left: ' + value + 'px')
          }, null, 12, _hoisted_1))
        }), 128)),
        _createElementVNode("img", {
          src: require('@/assets/icons/ufo.svg'),
          alt: "ufo-kun",
          id: "ufo"
        }, null, 8, _hoisted_2)
      ], 512))
    : _createCommentVNode("", true)
}
}

})